// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CancellationPolicies-space1-KenT2 {
	margin-bottom: 6px !important;
}

.CancellationPolicies-space2-PDI3s {
	margin-bottom: 12px !important;
}

.CancellationPolicies-space3-ezXIY {
	margin-bottom: 18px !important;
}

.CancellationPolicies-space4-fL75g {
	margin-bottom: 24px !important;
}

.CancellationPolicies-space5-jKIly {
	margin-bottom: 30px !important;
}

.CancellationPolicies-space6-esa9y {
	margin-bottom: 36px !important;
}

.CancellationPolicies-space7-IRhDV {
	margin-bottom: 42px !important;
}

.CancellationPolicies-spaceTop8-o_7yp {
	margin-bottom: 48px !important;
}

.CancellationPolicies-spaceTop1-Nxo5t {
	margin-top: 6px !important;
}

.CancellationPolicies-spaceTop2-ZuH2Y {
	margin-top: 12px !important;
}

.CancellationPolicies-spaceTop3-UlLZs {
	margin-top: 18px !important;
}

.CancellationPolicies-spaceTop4-fQi4o {
	margin-top: 24px !important;
}

.CancellationPolicies-spaceTop5-BAHMa {
	margin-top: 30px !important;
}

.CancellationPolicies-spaceTop6-xYAsV {
	margin-top: 36px !important;
}

.CancellationPolicies-spaceTop7-u5RSR {
	margin-top: 42px !important;
}

.CancellationPolicies-spaceTop8-o_7yp {
	margin-top: 48px !important;
}

.CancellationPolicies-noMargin-gom_8 {
	margin: 0px !important;
}

.CancellationPolicies-padding1-tz1HM {
	padding-bottom: 6px !important;
}

.CancellationPolicies-padding2-LYaor {
	padding-bottom: 12px !important;
}

.CancellationPolicies-padding3-nOjcw {
	padding-bottom: 18px !important;
}

.CancellationPolicies-padding4-UGdvt {
	padding-bottom: 24px !important;
}

.CancellationPolicies-padding5-IAwGP {
	padding-bottom: 30px !important;
}

.CancellationPolicies-padding6-Twtda {
	padding-bottom: 36px !important;
}

.CancellationPolicies-padding7-BgSAj {
	padding-bottom: 42px !important;
}

.CancellationPolicies-paddingTop1-Uivja {
	padding-top: 6px !important;
}

.CancellationPolicies-paddingTop2-PdfWy {
	padding-top: 12px !important;
}

.CancellationPolicies-paddingTop3-kCcDi {
	padding-top: 18px !important;
}

.CancellationPolicies-paddingTop4-GZOOO {
	padding-top: 24px !important;
}

.CancellationPolicies-paddingTop5-kYokh {
	padding-top: 30px !important;
}

.CancellationPolicies-paddingTop6-M0Uyz {
	padding-top: 36px !important;
}

.CancellationPolicies-paddingTop7-fh0Mx {
	padding-top: 42px !important;
}

.CancellationPolicies-noPadding-XAWvI {
	padding: 0px !important;
}

.CancellationPolicies-textBold-uufWG {
	font-weight: 500 !important;
}

.CancellationPolicies-textBolder-Lm94z {
	font-weight: 700 !important;
}

.CancellationPolicies-textNormal-oQuQc {
	font-weight: normal !important;
}

.CancellationPolicies-spaceBottom20-WnG34 {
	margin-bottom: 20px;
}

.CancellationPolicies-spaceBottom10-FHFWP {
	margin-bottom: 10px;
}

.CancellationPolicies-marginNone-myXFp {
	margin: 0;
}

.CancellationPolicies-spaceBottom15-lw3zX {
	margin-bottom: 15px;
}

.CancellationPolicies-marginTopNone-iiREG {
	margin-top: 0;
}

.CancellationPolicies-spaceTop11-vFdT_ {
	margin-top: 11px;
}

.CancellationPolicies-spaceTop21-ki9VJ {
	margin-top: 21px;
}

.CancellationPolicies-spaceTop20-HVmVB {
	margin-top: 20px;
}

.CancellationPolicies-spaceTop10-fZ8N8 {
	margin-top: 10px;
}

/*New Design Text Colors */

.CancellationPolicies-textDarkBlue-ramfF {
	color: rgb(20, 39, 94) !important;
}

.CancellationPolicies-textLightBlue-dZqej {
	color: rgb(57, 87, 106) !important;
}

.CancellationPolicies-textLightSandleGreen-DnB1i {
	color: rgb(76, 86, 41) !important;
}

.CancellationPolicies-textLightBrown-Q55I2 {
	color: rgb(115, 79, 33) !important;
}

.CancellationPolicies-textMediumMaroon-Cs_9G {
	color: rgb(87, 37, 51) !important;
}

.CancellationPolicies-textBrown-pBGj_ {
	color: rgb(160, 47, 24) !important;
}

.CancellationPolicies-textMaroon-UAmPr {
	color: rgb(155, 49, 67) !important;
}

.CancellationPolicies-textDarkBrown-QUrel {
	color: rgb(83, 18, 16) !important;
}

.CancellationPolicies-textMediumBrown-ed0OY {
	color: rgb(142, 28, 10) !important;
}

.CancellationPolicies-textSkyBlue-LAMqp {
	color: rgb(37, 117, 141) !important;
}

.CancellationPolicies-textGray-soO6Z {
	color: rgb(77, 65, 51) !important;
}

.CancellationPolicies-landingContainer-FfNF9 {
	max-width: var(--max-container-width);
	width: 100%;
	display: block;
	margin: 0 auto;
}

.CancellationPolicies-landingTitle-Cgsyh {
	font-size: 26px;
	margin: 30px 0 16px;
}

p {
	font-size: 14px
}

.CancellationPolicies-subText-RWAHn {
	font-size: 16px;
	color: var(--secondary-foreground);
	padding-left: 20px;
}

.CancellationPolicies-subText-RWAHn li {
	margin-bottom: 28px;
}

.CancellationPolicies-cancellationDesc-oXwJf {
	font-size: 16px;
	color: var(--secondary-foreground);
	margin: 0;
}

.CancellationPolicies-panelHeader-oLC9O {
	border-radius: 8px;
	width: 100%;
	font-size: 16px;
	padding: 0 34px 34px;
	border: 1px solid var(--primary-border);
	margin-top: 40px;
	margin-bottom: 50px;
}

.CancellationPolicies-tabItem-r52JW {
	display: block;
	padding: 28px 0px;
	position: relative;
	text-align: center;
	font-size: 20px;
	color: var(--primary-foreground);
	cursor: pointer;
	border-bottom: 2px solid transparent;
	font-weight: 600;
}

.CancellationPolicies-tabItem-r52JW:hover {
	text-decoration: none;
	color: var(--primary-foreground);
}

.CancellationPolicies-active-p0jfy .CancellationPolicies-tabItem-r52JW {
	color: var(--secondary-bg) !important;
	border-color: var(--secondary-bg);
	text-decoration: none;
}

.CancellationPolicies-noMargin-gom_8 {
	margin: 0px;
}

.CancellationPolicies-lineGraph-COnca {
	margin-top: 100px;
	padding-bottom: 50px;
	position: relative;
}

.CancellationPolicies-graphContainer-uHtvL {
	margin-left: 0px;
	margin-right: 0px;
}

.CancellationPolicies-toolLable-nvGYU {
	position: relative;
	left: -50%;
	top: 3px;
	text-align: center;
}

.CancellationPolicies-toolText-yuHHt {
	margin-top: 30px;
}

.CancellationPolicies-FlexibleTop-yH9TM {
	margin: 102px 0 0;
}

.CancellationPolicies-strictPadding-AIFiK {
	padding-bottom: 25px;
}

.CancellationPolicies-textCss-pKgXU {
	color: var(--secondary-foreground);
	font-size: 16px;
	margin-bottom: 13px;
}

.CancellationPolicies-boxOne-qvQXs {
	background-color: var(--cancel-policy-bg1);
	border-radius: 8px;
	padding: 30px;
	margin-top: 28px;
	color: var(--primary-foreground);
}

.CancellationPolicies-boxTwo-OMdLv {
	background-color: var(--cancel-policy-bg2);
	border-radius: 8px;
	padding: 30px;
	margin-top: 20px;
	color: var(--primary-foreground);
}

.CancellationPolicies-boxThree-IK1Pm {
	background-color: var(--cancel-policy-bg3);
	border-radius: 8px;
	padding: 30px;
	margin-top: 20px;
	color: var(--primary-foreground);
}

.CancellationPolicies-commonHeading-YbCZL {
	font-size: 18px;
	margin: 0 0 18px;
	font-weight: 600;
}

.CancellationPolicies-boxFour-inhsS {
	background-color: var(--primary-gray-bg);
	border-radius: 8px;
	padding: 30px 30px 2px;
}

.CancellationPolicies-lineBorder-XAYMa {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.CancellationPolicies-lineBreak-wSOPa {
	white-space: pre-line;
}

.CancellationPolicies-bulletPoint-TeTP_ {
	position: relative;
	list-style-type: none;
}

.CancellationPolicies-bulletPoint-TeTP_::before {
	content: '';
	font-size: 10px;
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--secondary-foreground);
	border-radius: 50%;
	left: -15px;
	top: 6px;
}

.CancellationPolicies-topPadding-UOMfJ {
	padding-top: 34px;
}

.CancellationPolicies-cancellationPolicyTabContainer-UUwj_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 72px;
	padding: 0;
	margin: 0 !important;
	border-bottom: 1px solid var(--primary-border);
}

.CancellationPolicies-cancellationPolicyTabContainer-UUwj_ li {
	list-style: none;
}

@media screen and (max-width:1200px) {
	.CancellationPolicies-landingContainer-FfNF9 {
		padding: 80px 20px 0;
	}
}

@media screen and (min-width:1201px) {
	.CancellationPolicies-landingContainer-FfNF9 {
		padding-left: 20px;
		padding-right: 20px;
	}
}

@media (max-width: 1023px) and (min-width: 768px) {
	.CancellationPolicies-panelHeader-oLC9O {
		padding-bottom: 195px;
	}
}

@media screen and (max-width: 767px) {
	.CancellationPolicies-hidesm-WU95N {
		display: none;
	}

	.CancellationPolicies-panelHeader-oLC9O {
		padding-bottom: 0;
	}

	.CancellationPolicies-strictPadding-AIFiK {
		padding-bottom: 0;
	}

	.CancellationPolicies-panelHeader-oLC9O {
		padding: 0 20px 34px;
	}

	.CancellationPolicies-topPadding-UOMfJ {
		padding-top: 24px;
	}

	.CancellationPolicies-tabItem-r52JW {
		padding: 20px 0px;
	}

	.CancellationPolicies-cancellationPolicyTabContainer-UUwj_ {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		gap: 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/CancellationPolicies/CancellationPolicies.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,qCAAqC;CACrC,WAAW;CACX,cAAc;CACd,cAAc;AACf;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,uCAAuC;CACvC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gCAAgC;CAChC,eAAe;CACf,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,gCAAgC;AACjC;;AAEA;CACC,qCAAqC;CACrC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAGA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,aAAa;CACb,gBAAgB;CAChB,gCAAgC;AACjC;;AAGA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,aAAa;CACb,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,aAAa;CACb,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,wCAAwC;CACxC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,WAAW;CACX,QAAQ;AACT;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;CACT,UAAU;CACV,oBAAoB;CACpB,8CAA8C;AAC/C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,MAAM;CACP;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.landingContainer {\n\tmax-width: var(--max-container-width);\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.landingTitle {\n\tfont-size: 26px;\n\tmargin: 30px 0 16px;\n}\n\np {\n\tfont-size: 14px\n}\n\n.subText {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tpadding-left: 20px;\n}\n\n.subText li {\n\tmargin-bottom: 28px;\n}\n\n.cancellationDesc {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0;\n}\n\n.panelHeader {\n\tborder-radius: 8px;\n\twidth: 100%;\n\tfont-size: 16px;\n\tpadding: 0 34px 34px;\n\tborder: 1px solid var(--primary-border);\n\tmargin-top: 40px;\n\tmargin-bottom: 50px;\n}\n\n.tabItem {\n\tdisplay: block;\n\tpadding: 28px 0px;\n\tposition: relative;\n\ttext-align: center;\n\tfont-size: 20px;\n\tcolor: var(--primary-foreground);\n\tcursor: pointer;\n\tborder-bottom: 2px solid transparent;\n\tfont-weight: 600;\n}\n\n.tabItem:hover {\n\ttext-decoration: none;\n\tcolor: var(--primary-foreground);\n}\n\n.active .tabItem {\n\tcolor: var(--secondary-bg) !important;\n\tborder-color: var(--secondary-bg);\n\ttext-decoration: none;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.lineGraph {\n\tmargin-top: 100px;\n\tpadding-bottom: 50px;\n\tposition: relative;\n}\n\n.graphContainer {\n\tmargin-left: 0px;\n\tmargin-right: 0px;\n}\n\n\n.toolLable {\n\tposition: relative;\n\tleft: -50%;\n\ttop: 3px;\n\ttext-align: center;\n}\n\n.toolText {\n\tmargin-top: 30px;\n}\n\n.FlexibleTop {\n\tmargin: 102px 0 0;\n}\n\n.strictPadding {\n\tpadding-bottom: 25px;\n}\n\n.textCss {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n\tmargin-bottom: 13px;\n}\n\n.boxOne {\n\tbackground-color: var(--cancel-policy-bg1);\n\tborder-radius: 8px;\n\tpadding: 30px;\n\tmargin-top: 28px;\n\tcolor: var(--primary-foreground);\n}\n\n\n.boxTwo {\n\tbackground-color: var(--cancel-policy-bg2);\n\tborder-radius: 8px;\n\tpadding: 30px;\n\tmargin-top: 20px;\n\tcolor: var(--primary-foreground);\n}\n\n.boxThree {\n\tbackground-color: var(--cancel-policy-bg3);\n\tborder-radius: 8px;\n\tpadding: 30px;\n\tmargin-top: 20px;\n\tcolor: var(--primary-foreground);\n}\n\n.commonHeading {\n\tfont-size: 18px;\n\tmargin: 0 0 18px;\n\tfont-weight: 600;\n}\n\n.boxFour {\n\tbackground-color: var(--primary-gray-bg);\n\tborder-radius: 8px;\n\tpadding: 30px 30px 2px;\n}\n\n.lineBorder {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.lineBreak {\n\twhite-space: pre-line;\n}\n\n.bulletPoint {\n\tposition: relative;\n\tlist-style-type: none;\n}\n\n.bulletPoint::before {\n\tcontent: '';\n\tfont-size: 10px;\n\tposition: absolute;\n\twidth: 8px;\n\theight: 8px;\n\tbackground: var(--secondary-foreground);\n\tborder-radius: 50%;\n\tleft: -15px;\n\ttop: 6px;\n}\n\n.topPadding {\n\tpadding-top: 34px;\n}\n\n.cancellationPolicyTabContainer {\n\tdisplay: flex;\n\tgap: 72px;\n\tpadding: 0;\n\tmargin: 0 !important;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.cancellationPolicyTabContainer li {\n\tlist-style: none;\n}\n\n@media screen and (max-width:1200px) {\n\t.landingContainer {\n\t\tpadding: 80px 20px 0;\n\t}\n}\n\n@media screen and (min-width:1201px) {\n\t.landingContainer {\n\t\tpadding-left: 20px;\n\t\tpadding-right: 20px;\n\t}\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.panelHeader {\n\t\tpadding-bottom: 195px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.hidesm {\n\t\tdisplay: none;\n\t}\n\n\t.panelHeader {\n\t\tpadding-bottom: 0;\n\t}\n\n\t.strictPadding {\n\t\tpadding-bottom: 0;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 0 20px 34px;\n\t}\n\n\t.topPadding {\n\t\tpadding-top: 24px;\n\t}\n\n\t.tabItem {\n\t\tpadding: 20px 0px;\n\t}\n\n\t.cancellationPolicyTabContainer {\n\t\tflex-direction: column;\n\t\tgap: 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `CancellationPolicies-space1-KenT2`,
	"space2": `CancellationPolicies-space2-PDI3s`,
	"space3": `CancellationPolicies-space3-ezXIY`,
	"space4": `CancellationPolicies-space4-fL75g`,
	"space5": `CancellationPolicies-space5-jKIly`,
	"space6": `CancellationPolicies-space6-esa9y`,
	"space7": `CancellationPolicies-space7-IRhDV`,
	"spaceTop8": `CancellationPolicies-spaceTop8-o_7yp`,
	"spaceTop1": `CancellationPolicies-spaceTop1-Nxo5t`,
	"spaceTop2": `CancellationPolicies-spaceTop2-ZuH2Y`,
	"spaceTop3": `CancellationPolicies-spaceTop3-UlLZs`,
	"spaceTop4": `CancellationPolicies-spaceTop4-fQi4o`,
	"spaceTop5": `CancellationPolicies-spaceTop5-BAHMa`,
	"spaceTop6": `CancellationPolicies-spaceTop6-xYAsV`,
	"spaceTop7": `CancellationPolicies-spaceTop7-u5RSR`,
	"noMargin": `CancellationPolicies-noMargin-gom_8`,
	"padding1": `CancellationPolicies-padding1-tz1HM`,
	"padding2": `CancellationPolicies-padding2-LYaor`,
	"padding3": `CancellationPolicies-padding3-nOjcw`,
	"padding4": `CancellationPolicies-padding4-UGdvt`,
	"padding5": `CancellationPolicies-padding5-IAwGP`,
	"padding6": `CancellationPolicies-padding6-Twtda`,
	"padding7": `CancellationPolicies-padding7-BgSAj`,
	"paddingTop1": `CancellationPolicies-paddingTop1-Uivja`,
	"paddingTop2": `CancellationPolicies-paddingTop2-PdfWy`,
	"paddingTop3": `CancellationPolicies-paddingTop3-kCcDi`,
	"paddingTop4": `CancellationPolicies-paddingTop4-GZOOO`,
	"paddingTop5": `CancellationPolicies-paddingTop5-kYokh`,
	"paddingTop6": `CancellationPolicies-paddingTop6-M0Uyz`,
	"paddingTop7": `CancellationPolicies-paddingTop7-fh0Mx`,
	"noPadding": `CancellationPolicies-noPadding-XAWvI`,
	"textBold": `CancellationPolicies-textBold-uufWG`,
	"textBolder": `CancellationPolicies-textBolder-Lm94z`,
	"textNormal": `CancellationPolicies-textNormal-oQuQc`,
	"spaceBottom20": `CancellationPolicies-spaceBottom20-WnG34`,
	"spaceBottom10": `CancellationPolicies-spaceBottom10-FHFWP`,
	"marginNone": `CancellationPolicies-marginNone-myXFp`,
	"spaceBottom15": `CancellationPolicies-spaceBottom15-lw3zX`,
	"marginTopNone": `CancellationPolicies-marginTopNone-iiREG`,
	"spaceTop11": `CancellationPolicies-spaceTop11-vFdT_`,
	"spaceTop21": `CancellationPolicies-spaceTop21-ki9VJ`,
	"spaceTop20": `CancellationPolicies-spaceTop20-HVmVB`,
	"spaceTop10": `CancellationPolicies-spaceTop10-fZ8N8`,
	"textDarkBlue": `CancellationPolicies-textDarkBlue-ramfF`,
	"textLightBlue": `CancellationPolicies-textLightBlue-dZqej`,
	"textLightSandleGreen": `CancellationPolicies-textLightSandleGreen-DnB1i`,
	"textLightBrown": `CancellationPolicies-textLightBrown-Q55I2`,
	"textMediumMaroon": `CancellationPolicies-textMediumMaroon-Cs_9G`,
	"textBrown": `CancellationPolicies-textBrown-pBGj_`,
	"textMaroon": `CancellationPolicies-textMaroon-UAmPr`,
	"textDarkBrown": `CancellationPolicies-textDarkBrown-QUrel`,
	"textMediumBrown": `CancellationPolicies-textMediumBrown-ed0OY`,
	"textSkyBlue": `CancellationPolicies-textSkyBlue-LAMqp`,
	"textGray": `CancellationPolicies-textGray-soO6Z`,
	"landingContainer": `CancellationPolicies-landingContainer-FfNF9`,
	"landingTitle": `CancellationPolicies-landingTitle-Cgsyh`,
	"subText": `CancellationPolicies-subText-RWAHn`,
	"cancellationDesc": `CancellationPolicies-cancellationDesc-oXwJf`,
	"panelHeader": `CancellationPolicies-panelHeader-oLC9O`,
	"tabItem": `CancellationPolicies-tabItem-r52JW`,
	"active": `CancellationPolicies-active-p0jfy`,
	"lineGraph": `CancellationPolicies-lineGraph-COnca`,
	"graphContainer": `CancellationPolicies-graphContainer-uHtvL`,
	"toolLable": `CancellationPolicies-toolLable-nvGYU`,
	"toolText": `CancellationPolicies-toolText-yuHHt`,
	"FlexibleTop": `CancellationPolicies-FlexibleTop-yH9TM`,
	"strictPadding": `CancellationPolicies-strictPadding-AIFiK`,
	"textCss": `CancellationPolicies-textCss-pKgXU`,
	"boxOne": `CancellationPolicies-boxOne-qvQXs`,
	"boxTwo": `CancellationPolicies-boxTwo-OMdLv`,
	"boxThree": `CancellationPolicies-boxThree-IK1Pm`,
	"commonHeading": `CancellationPolicies-commonHeading-YbCZL`,
	"boxFour": `CancellationPolicies-boxFour-inhsS`,
	"lineBorder": `CancellationPolicies-lineBorder-XAYMa`,
	"lineBreak": `CancellationPolicies-lineBreak-wSOPa`,
	"bulletPoint": `CancellationPolicies-bulletPoint-TeTP_`,
	"topPadding": `CancellationPolicies-topPadding-UOMfJ`,
	"cancellationPolicyTabContainer": `CancellationPolicies-cancellationPolicyTabContainer-UUwj_`,
	"hidesm": `CancellationPolicies-hidesm-WU95N`
};
module.exports = ___CSS_LOADER_EXPORT___;
